import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase environment variables are not configured.");
}

// Custom auth lock to prevent cross-tab lock contention deadlocks.
// Wraps the Navigator LockManager with a hard timeout cap.
function customLock(
  name: string,
  acquireTimeout: number,
  fn: () => Promise<unknown>
): Promise<unknown> {
  if (typeof navigator !== "undefined" && "locks" in navigator) {
    const signal = AbortSignal.timeout(acquireTimeout);
    return navigator.locks.request(name, { signal }, async () => {
      await fn();
    });
  }
  return fn();
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  lock: customLock as never,
});